export function isNumber(v) {
    return typeof v === 'number';
}
export function isNumberLike(v) {
    return v !== null && (typeof v === 'number' || !isNaN(v));
}
export function isString(v) {
    return typeof v === 'string';
}
export function isBoolean(v) {
    return typeof v === 'boolean';
}
export function isUndefined(v) {
    return v === undefined;
}
export function isNull(v) {
    return v === null;
}
/**
 * checks if given value is an object. `null` will return false, and arrays will return true;
 */
export function isObject(v) {
    if (v === null)
        return false;
    return v instanceof Object;
}
export function isArray(v) {
    return v instanceof Array;
}
export function isFunction(v) {
    return typeof v === 'function';
}
export function isAsyncFunction(fn) {
    var _a;
    return ((_a = fn === null || fn === void 0 ? void 0 : fn.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'AsyncFunction';
}
export function isGeneratorFunction(fn) {
    var _a;
    return ((_a = fn === null || fn === void 0 ? void 0 : fn.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'AsyncFunction';
}
export function isReactComponentClass(component) {
    var _a;
    return (typeof component === 'function' &&
        !!((_a = component === null || component === void 0 ? void 0 : component.prototype) === null || _a === void 0 ? void 0 : _a.isReactComponent));
}
/**
 * native arrows don't have prototypes; class components have special prototype property 'isReactComponent'
 */
export function isReactFunctionalComponent(component) {
    var _a;
    if (!component)
        return false;
    return (typeof component === 'function' // can be various things
        && (!(component === null || component === void 0 ? void 0 : component.prototype) || !((_a = component === null || component === void 0 ? void 0 : component.prototype) === null || _a === void 0 ? void 0 : _a.isReactComponent)));
}
export function isReactComponent(component) {
    return (isReactComponentClass(component) ||
        isReactFunctionalComponent(component));
}
export function isLazyComponent(component) {
    var _a;
    return isObject(component) && ((_a = component === null || component === void 0 ? void 0 : component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === 'Symbol(react.lazy)';
}
export function isMemoizedComponent(component) {
    var _a;
    return isObject(component) && ((_a = component === null || component === void 0 ? void 0 : component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === 'Symbol(react.memo)';
}
export var isAnyReactComponent = function (component) {
    return isObject(component) && (true);
};
